import { createApp } from "vue";
import { pinia } from "./stores/main";
import App from "./App.vue";
import DataTable from "@/components/form/DataTable.vue";
import RadioButton from "@/components/form/RadioButton.vue";
import UpdateInfoStep2 from "@/components/profile/personal-info/UpdateInfoStep2.vue";
import LoaderComponent from "@/components/utils/LoaderComponent.vue";
import Alerts from "@components/utils/AlertsComponent.vue";
import MessageCard from "@components/cards/MessageCard.vue";
import router from "./router";
import "./services/axiosConfig";
import { openAnthemSso } from "./services/anthemSso";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/scss/style.scss";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const app = createApp(App);
app.use(pinia); // Using the Pinia store
app.use(VueReCaptcha, {
    siteKey: '6Ld-28YqAAAAAGQoC9Pq4ClLJBj_Nt6JRuxRWWT9',
    loaderOptions: {
        autoHideBadge: true,
    }
});
app.use(Toast);

// Extend `window` interface for TypeScript
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

// Load Google Analytics script dynamically
const loadGoogleAnalytics = () => {
        // Prevent duplicate loading
        if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) return;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-WY013LYBFY";
        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function (...args) {
                window.dataLayer.push(args);
            };
            window.gtag("js", new Date());
            window.gtag("config", "G-WY013LYBFY");
        };
        script.onerror = () => {
            console.error("Error loading Google Analytics script.");
        };
        document.head.appendChild(script);
    };

// Call the function to load GA
loadGoogleAnalytics();

// Track page views on route change
router.afterEach((to) => {
    if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
            page_path: to.fullPath,
            page_title: to.name || document.title,
        });
    } else {
        console.warn("Google Analytics not loaded yet.");
    }
});


app.component("DataTable", DataTable);
app.component("RadioButton", RadioButton);
app.component("UpdateInfoStep2", UpdateInfoStep2);
app.component("LoaderComponent", LoaderComponent);
app.component("AlertsComponent", Alerts);
app.component("MessageCard", MessageCard);

// Anthem inbound SSO trigger, callable from any template as `$anthemSsoLogin`.
app.config.globalProperties.$anthemSsoLogin = openAnthemSso;

app.use(router);
app.mount("#app");
